import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { GeneralTable } from 'src/components/general';
import GeneralFiltersAccordionWrapper from 'src/components/general/GeneralFiltersAccordionWrapper';
import { GIFT_CODE_INDEX_TABLE_HEAD } from 'src/constants/tableHeads';
import useTable from 'src/hooks/useTable';
import { useGiftIndexList } from 'src/network/subscribe-package/giftcode-generation';
import GiftListTableRow from 'src/sections/@dashboard/subscribeListPage/giftListTableRow';
import useFormsModalStore from 'src/store/forms';
import GiftCodeListTableToolbar from './GiftCodeListTableToolbar';

const GiftCodeIndex = () => {
  const { projectId } = useParams();

  const useTableOptions = useTable();
  const { page, onChangePage } = useTableOptions;

  const { modal } = useFormsModalStore();
  const subscribePackageId = modal?.data;

  const [tableData, setTableData] = useState([]);

  const [filterItems, setFilterItems] = useState({
    AppID: +projectId,
    SubscribePackageID: +subscribePackageId,
    Code: '',
    Label: '',
    Status: -1,
  });

  const { data, isLoading } = useGiftIndexList(filterItems, page);

  useEffect(() => {
    if (data) {
      const result = data?.items || [];
      setTableData([...result]);
    }
  }, [data, page]);

  return (
    <div>
      <GeneralFiltersAccordionWrapper>
        <GiftCodeListTableToolbar onChangePage={onChangePage} filterItems={filterItems} setFilterItems={setFilterItems} />
      </GeneralFiltersAccordionWrapper>

      <GeneralTable
        isLoading={isLoading}
        tableData={tableData}
        headLabel={GIFT_CODE_INDEX_TABLE_HEAD}
        hasDeleteOption={false}
        CustomTableRow={GiftListTableRow}
        useTableOptions={useTableOptions}
      />
    </div>
  );
};

export default GiftCodeIndex;
